import {  IOrderItem, IBopisOrderStatus } from '@/interfaces/orders';
import { create } from 'zustand';

interface OrderState {
  showSplitOrderWarningMessage: boolean;
  setShowSplitOrderWarningMessage: (showSplitOrderWarningMessage: boolean) => void;
  selectedProductsForReturn: IOrderItem[];
  setSelectedProductsForReturn: (selectedProductsForReturn: IOrderItem[])=> void;
  bopisOrders: IBopisOrderStatus[];
  setBopisOrders: (bopisOrders: IBopisOrderStatus[]) => void;

}

export const useOrderStore = create<OrderState>((set) => ({
  showSplitOrderWarningMessage: false,
  setShowSplitOrderWarningMessage: (show) => set({ showSplitOrderWarningMessage: show }),
  selectedProductsForReturn: [],
  setSelectedProductsForReturn: (products) => 
    set({ selectedProductsForReturn: products }),
    bopisOrders: [],
  setBopisOrders: (bopisOrders) => set({ bopisOrders }),
}));
